import { getLocales } from 'modules/common/lib/helpers/i18n/getLocales'
import { EnumUserLocale } from 'modules/common/types/locale'

// Moves the user's locale in first position
export const sortAvailableLocales = (userLocale: EnumUserLocale) =>
  getLocales().sort((a, b) =>
    a === userLocale ? -1 : b === userLocale ? 1 : 0
  )
